import styled from '@emotion/styled';
import FormItem from 'app/components/Form/FormItem';
export const StyledFormItem = styled(FormItem)`
  padding-left: 20px;
  margin-bottom: 16px;
  .ant-form-item-label {
    padding-bottom: 4px;
  }
`;
